// extracted by mini-css-extract-plugin
export default {"container":"ApprovalRuleItem_container__HchBG","groupFields":"ApprovalRuleItem_groupFields__SRJ4k","addRow":"ApprovalRuleItem_addRow__2jFS1","input":"ApprovalRuleItem_input__KxA22"};